export default function calculateRisk(answers, questions) {
  let rawScore = 0;

  questions.forEach((question) => {
    const answer = answers[question.id];

    if (question.multiple) {
      answer.forEach((value) => {
        const option = question.options.find(
          (o) => o.value === value
        );

        if (option) rawScore += option.score;
      });
    } else {
      const option = question.options.find(
        (o) => o.value === answer
      );

      if (option) rawScore += option.score;
    }
  });

  const percentage = Math.round((rawScore / 26) * 100);

  let result = {
    percentage,
    badge: "",
    summary: "",
    color: "",
    singleLoss: "",
    seasonLoss: "",
  };

  if (percentage < 35) {
  result.badge = 'RiskCalculator.result.badge.low';
  result.color = '#639922';
  result.summary = 'RiskCalculator.result.summary.low';
  result.singleLoss = 'RiskCalculator.result.loss.low.single';
  result.seasonLoss = 'RiskCalculator.result.loss.low.season';
} else if (percentage < 65) {
  result.badge = 'RiskCalculator.result.badge.medium';
  result.color = '#ba7517';
  result.summary = 'RiskCalculator.result.summary.medium';
  result.singleLoss = 'RiskCalculator.result.loss.medium.single';
  result.seasonLoss = 'RiskCalculator.result.loss.medium.season';
} else {
  result.badge = 'RiskCalculator.result.badge.high';
  result.color = '#e24b4a';
  result.summary = 'RiskCalculator.result.summary.high';
  result.singleLoss = 'RiskCalculator.result.loss.high.single';
  result.seasonLoss = 'RiskCalculator.result.loss.high.season';
}

  return result;
}